export var KeyResultType;
(function (KeyResultType) {
    KeyResultType["MAXIMUM"] = "maximum";
    KeyResultType["MINIMUM"] = "minimum";
})(KeyResultType || (KeyResultType = {}));
